// extracted by mini-css-extract-plugin
module.exports = {"dots":"_3AUc6B","dot":"iwaRLz","active":"_1lnCmy"};